export default Object.freeze({
  colors: {
    background: "#001023",
    green: "#00EEB8",
    text: "white",
    lightBlue: "#44709f",
    blue: "#19324D",
    darkBlue: "#091B2F",
    darkBlue2: "#103156",
    brand: "#1A67FF",
    whiteSmoke: "#D1D8E0",
  },
  gridBreakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1620,
  },
});
